import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "main__welcome" }

import { APP } from "@/pwa";
import { useLangStore } from "@/store/lang";
import { computed } from "vue";
import TopBar from "@/components/TopBar.vue";
import BaseNotecard from "@/components/UI/BaseNotecard.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainView',
  setup(__props) {

const lang = useLangStore();

const messages = computed(() => {
  return lang.messages.mainView;
});

const installApp = () => {
  APP.startChromeInstall();
};

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(TopBar, null, {
      default: _withCtx(() => [
        _createElementVNode("h1", null, _toDisplayString(_unref(messages).payment), 1)
      ]),
      _: 1
    }),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(BaseNotecard, null, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_unref(messages).hello), 1),
          _createElementVNode("article", null, [
            _createElementVNode("p", null, _toDisplayString(_unref(messages).desc1), 1),
            _createElementVNode("p", null, _toDisplayString(_unref(messages).desc2), 1),
            _createVNode(_component_base_button, {
              class: "button",
              onClick: installApp
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(messages).download), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_base_button, {
              class: "button",
              mode: "flat",
              link: "",
              to: "auth"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(messages).login), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})